(function () {
  'use strict';

  function initRecTabs(section) {
    var tabs = section.querySelectorAll('[data-rec-tab]');
    var panels = section.querySelectorAll('[data-rec-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-rec-tab');
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });
        tab.classList.add('is-active');
        var panel = section.querySelector('[data-rec-panel="' + id + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pk-rec]').forEach(initRecTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
